import tokenManager from './tokenManager';

declare global {
  interface Window {
    tokenDebug: {
      getToken: () => string | null;
      getRefreshToken: () => string | null;
      isExpired: () => boolean;
      forceRefresh: () => Promise<string | null>;
      clear: () => void;
      timeLeft: () => string;
      info: () => any;
      setTokens: (access: string, refresh?: string) => void;
      ensureValid: () => Promise<string | null>;
    };
  }
}

export const initTokenDebug = () => {
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    window.tokenDebug = {
      getToken: () => tokenManager.getAccessToken(),
      getRefreshToken: () => tokenManager.getRefreshToken(),
      isExpired: () => tokenManager.isTokenExpired(),
      forceRefresh: () => tokenManager.refreshAccessToken(),
      clear: () => tokenManager.clearTokens(),
      timeLeft: () => {
        const token = tokenManager.getAccessToken();
        if (!token) return 'No token';

        const expiry = tokenManager.getTokenExpiry();
        const timeUntilExpiry = tokenManager.getTimeUntilExpiry();

        if (!expiry) return 'Invalid token';

        if (timeUntilExpiry && timeUntilExpiry > 0) {
          const hours = Math.floor(timeUntilExpiry / (1000 * 60 * 60));
          const minutes = Math.floor((timeUntilExpiry % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeUntilExpiry % (1000 * 60)) / 1000);

          return `Expires at ${expiry.toLocaleString()} (${hours}h ${minutes}m ${seconds}s remaining)`;
        }

        return `Expired at ${expiry.toLocaleString()}`;
      },
      info: () => tokenManager.getTokenDebugInfo(),
      setTokens: (access: string, refresh?: string) => tokenManager.setTokens(access, refresh),
      ensureValid: () => tokenManager.ensureValidToken(),
    };

  }
};

export default initTokenDebug;